<h3 id="{{ config.id }}">
  {{ config.name }}
  <a [routerLink]="['../', config.scope]" fragment="{{ config.id }}">#</a>
</h3>
